import api from './BaseAPI.js'
import auth from './AuthAPI.js'
import * as APPCONFIG from '../config/app-config.js'
import Http from './Http.js';

class LoginService {
    doLogout() {
        return auth({
            method: 'post',
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/logout`
        })
    }
       
    isLogin() {
        return auth({
            method: 'post',
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}islogin`
        })
    }
    
    

    getLoginValues(formValues) {
        return auth({
            method: 'post',
            headers: Http.AUTH_HEADERS(),
            url: `${APPCONFIG.API_URL}api/login`,
            data: JSON.stringify(formValues)
        })
    }

    //* NON AUTH *//
     getLogin(formValues) {
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/weblogin`,
            data: JSON.stringify(formValues)
        })
    }

    createInstantUser(formValues) {
        return api({
            method: 'POST',
            url: `${APPCONFIG.API_URL}auth/InstanceNewLoginAccount`,
            data: JSON.stringify(formValues)
        })
    }

    
    checkOTPVaild(formValues) {
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/checkOTPVaild`,
            data: JSON.stringify(formValues)
        })
    }

    sendOTP(formValues) {
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/sendotp`,
            data: JSON.stringify(formValues)
        })
    }

    mobilePasswordChanged(formValues) {
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/mobilePasswordChanged`,
            data: JSON.stringify(formValues)
        })
    }

    forgotPasswordMobile(formValues) {
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/forgotPasswordMobile`,
            data: JSON.stringify(formValues)
        })
    }


    firstTimeUser(formValues){
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/firstTimeUser`,
            data: JSON.stringify(formValues)
        })
    }


    firstTimeUserResend(formValues) {
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/firstTimeUserResend`,
            data: JSON.stringify(formValues)
        })
    }



    setForgotPassword(formValues) {
        return api({
            method: 'post',
            url: `${APPCONFIG.API_URL}auth/webPasswordChanged`,
            data: JSON.stringify(formValues)
        })
    }







    
   getMsLogin(formValues) {
    return api({
        method: 'post',
        url: `${APPCONFIG.API_URL}auth/MSLogin`,
        data: JSON.stringify(formValues)
    })
}

saveUserProfile(formValues) {
    return api({
        method: 'post',
        url: `${APPCONFIG.API_URL}auth/saveuserdetail`,
        data: JSON.stringify(formValues)
    })
}
}

export default new LoginService();